Object.defineProperty(exports, "__esModule", {value: true});

exports.default = {
	Enum: {}
};